import React from 'react';
import { useTranslation } from 'localization';
import ButtonAtom from '../Button/ButtonAtom';
import './DateNavigatorAtom.scss';

export interface DateNavigatorAtomProps {
  windowLabel: string;
  onPrev: () => void;
  onNext: () => void;
  onNow: () => void;
  hasPrev?: boolean;
  hasNext?: boolean;
  className?: string;
}

const DateNavigatorAtom: React.FC<DateNavigatorAtomProps> = ({
  windowLabel,
  onPrev,
  onNext,
  onNow,
  hasPrev = true,
  hasNext = true,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <nav
      className={className ? `date-navigator ${className}` : 'date-navigator'}
      aria-label={t('periodSelector.dateNavigator.label')}
    >
      <ButtonAtom
        icon="pi pi-chevron-left"
        variant="secondary"
        size="small"
        shape="pill"
        onClick={onPrev}
        disabled={!hasPrev}
        aria-label={t('periodSelector.dateNavigator.prevWindow')}
      />

      <span className="date-navigator__window-label">{windowLabel}</span>

      <ButtonAtom
        icon="pi pi-chevron-right"
        variant="secondary"
        size="small"
        shape="pill"
        onClick={onNext}
        disabled={!hasNext}
        aria-label={t('periodSelector.dateNavigator.nextWindow')}
      />

      <ButtonAtom
        label={t('periodSelector.dateNavigator.now')}
        variant="secondary"
        size="small"
        shape="pill"
        onClick={onNow}
        aria-label={t('periodSelector.dateNavigator.now')}
      />
    </nav>
  );
};

export default DateNavigatorAtom;
